import Action from "./action";

export default class LoadState extends Action {
    states;
    patchState;
    loadViewpoint;
    appendState;
    viewpointApplyMode;
    positionOnlyInXR;

    constructor(props) {
        super(props);
        this.states = props.states || [];
        this.disabled = props.disabled;
        this.patchState = props.patchState ? props.patchState : false;
        this.loadViewpoint = !!props.loadViewpoint;
        this.appendState = props.appendState ? props.appendState : false;
        this.viewpointApplyMode = props.viewpointApplyMode || '2D';
        this.positionOnlyInXR = props.positionOnlyInXR || false;
    }

    async execute(eventLoop) {
        const training = eventLoop.training;

        if (await Action.parseValue(this.disabled, eventLoop)) {
            return;
        }

        training.prepareStates(this.states);
        await training.loadStates({
            patchState: this.patchState,
            loadViewpoint: this.loadViewpoint,
            appendState: this.appendState,
            viewpointApplyMode: this.viewpointApplyMode,
            positionOnlyInXR: this.positionOnlyInXR
        });
    }
}
